import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import { connect } from 'react-redux';
import { log } from '@emyw/core-lib';
import Step4ConfirmDetails from '@emyw/subscribe-lib/Step4ConfirmDetails';
import { ValidateStep } from './index';
import { withAppContext } from '../AppContext';
import { loadUser } from '../actions/userActions';

const {
    REACT_APP_JOYIFY_EXTENSION_ID,
    REACT_APP_ENJOY_EXTENSION_ID,
    REACT_APP_ENJOY_SITE_ROOT_URL,
    NODE_ENV,
    REACT_APP_TOKEN_NAME,
    REACT_APP_REFRESH_TOKEN_NAME,
} = process.env;

class ConfirmSignUp extends Component {
    state = {
        proceedTo: undefined,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            if (directTo !== 'confirm') this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'confirm' });
        // if (user) {
        //     ValidateStep(window.location, user).then((directTo) => {
        //         if (directTo !== 'confirm') this.setState({ proceedTo: directTo });
        //     });
        // } else {
        //     this.setState({ proceedTo: 'setupaccount' });
        // }
    }

    // setNextLocation = (pathname) => {
    //     localStorage.setItem('enjoy-signup-progress', pathname);
    //     this.setState({ proceedTo: pathname });
    // }

    getAuthTokens = () => (
        {
            token: localStorage.getItem(REACT_APP_TOKEN_NAME),
            refreshToken: localStorage.getItem(REACT_APP_REFRESH_TOKEN_NAME),
        }
    );

    handleComplete = () => {
        // this.setState({ proceedTo: 'signupcomplete' });
        loadUser('network-only')(({ user }) => {
            const { context } = this.props;
            const authTokens = this.getAuthTokens();
            context.setAppState({ user });
            this.setState({ proceedTo: 'manageprofilesintro' });
            /* Send new auth tokens to extensions */
            if (window.chrome) {
                if (REACT_APP_ENJOY_EXTENSION_ID || REACT_APP_JOYIFY_EXTENSION_ID) {
                    log.trace('sending tokens to extensions');
                    if (REACT_APP_ENJOY_EXTENSION_ID) {
                        try {
                            window.chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, { authTokens });
                        } catch (error) {
                            log.warn('Attempt to notify Enjoy Chrome extension failed. Perhaps an unsupported browser is being used.');
                        }
                    }
                    if (REACT_APP_JOYIFY_EXTENSION_ID) {
                        try {
                            window.chrome.runtime.sendMessage(REACT_APP_JOYIFY_EXTENSION_ID, { authTokens });
                        } catch (error) {
                            log.warn('Attempt to notify Joyify-it Chrome extension failed. Perhaps an unsupported browser is being used.');
                        }
                    }
                }
            } else {
                log.warn('Cannot notify extension - window.chrome undefined. Perhaps an unsupported browser is being used.');
            }
        });
    };

    handleChangeEmailClick = () => {
        this.setState({ proceedTo: 'newaccount' });
    }

    handleChangePlanClick = () => {
        this.setState({ proceedTo: 'plan' });
    };

    handleEditPaymentClick = () => {
        this.setState({ proceedTo: 'payment' });
    };

    handleTermsClick = () => {
        // alert('terms');
        const { context } = this.props;
        context.setAppState({ termsModalOpen: true });
    }

    handlePrivacyClick = () => {
        // alert('privacy');
        const { context } = this.props;
        context.setAppState({ policyModalOpen: true });
    }

    render() {
        const { context } = this.props;
        const { user, skipPlanSelect } = context.state;
        // log.trace('user', user);
        const { proceedTo } = this.state;
        const authTokens = this.getAuthTokens();
        // console.log(authTokens, NODE_ENV, REACT_APP_ENJOY_SITE_ROOT_URL, proceedTo);

        if (proceedTo === 'manageprofilesintro') {
            if (NODE_ENV !== 'production') {
                // eslint-disable-next-line max-len
                const testingLocation = `${REACT_APP_ENJOY_SITE_ROOT_URL}/manageprofilesintro?token=${authTokens.token}&refreshToken=${authTokens.refreshToken}`;
                log.trace(testingLocation);
                // debugger;
                window.location = testingLocation;
            } else {
                // return <Redirect push to="/manageprofilesintro" />;
                return <Redirect push to="/tvapp?n=true" />;
            }
        } else if (proceedTo) {
            return <Redirect push to={`/signup/${proceedTo}`} />;
        }

        return (
            <div>
                <Helmet>
                    <title>Enjoy Signup - Confirm</title>
                    <meta name="description" content="Confirm signup" />
                </Helmet>
                {user && (
                    <Step4ConfirmDetails
                        user={user}
                        onComplete={this.handleComplete}
                        onChangePlanClick={this.handleChangePlanClick}
                        onChangeEmailClick={this.handleChangeEmailClick}
                        onTermsClick={this.handleTermsClick}
                        onPrivacyClick={this.handlePrivacyClick}
                        onEditPaymentClick={this.handleEditPaymentClick}
                        planSelectDisabled={skipPlanSelect}
                        context={context}
                        darkMode
                        loadUser={loadUser}
                    />
                )}
            </div>
        );
    }
}

// const mapStateToProps = state => ({ user: state.user });

// export default connect(mapStateToProps)(ConfirmSignUp);
export default withAppContext(ConfirmSignUp);
